<label *ngIf="label" class="font-weight-bold">{{ label }}</label>
<select
  #select
  *ngIf="items.length > 1 || !collapse"
  class="form-control"
  (change)="onSelectChange(select.value)">
  <option *ngFor="let item of items" [id]="item.id + '-option'" [value]="item.value ?? item.label">
    {{ item.label }}
  </option>
</select>
<slot #itemSlot (slotchange)="onSlottedContentChanged()"></slot>
